import ConfirmEmailContainer from './confirm_email_container';

const ConfirmEmail = ConfirmEmailContainer;
export default ConfirmEmail;
